/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';

import { jsx } from '@compiled/react';

import { type DocNode } from '@atlaskit/adf-schema';
import { css } from '@atlaskit/css';
import { type NodeComponentsProps, ReactRenderer } from '@atlaskit/renderer';
import { token } from '@atlaskit/tokens';

import type { AuditLogEventActivity } from '../../utils/types';

// Note: ideally this would be taken care of by the renderer, but it's not
// so we need to style it manually
const activityMessageContainerStyle = css({
	font: token('font.body'),
});

const ActivityParagraphStyle = ({ children }: { children: React.ReactNode }) => (
	<div css={activityMessageContainerStyle}>{children}</div>
);

const activityStyles: NodeComponentsProps = {
	paragraph: ActivityParagraphStyle,
};

interface ActivityMessageProps {
	activity?: AuditLogEventActivity;
}

export const ActivityMessage = ({ activity }: ActivityMessageProps): JSX.Element | null => {
	if (activity === undefined || activity?.message === undefined) {
		return null;
	}

	if (activity.type === 'adf') {
		const activityDocument: DocNode = JSON.parse(activity.message);
		return <ReactRenderer document={activityDocument} nodeComponents={activityStyles} />;
	}

	return <React.Fragment>{activity.message}</React.Fragment>;
};
